import { Stack, Button, Group } from "@mantine/core"
import { useTranslation } from "react-i18next"
import { UseMutationResult } from "@tanstack/react-query"
import { DatePickerInput } from "@mantine/dates"
import { DefaultModal } from "@components/default-modal"

interface ReturnModalProps {
  opened: boolean
  onClose: () => void
  returnEndDate: Date | null
  setReturnEndDate: (date: Date | null) => void
  activeBorrow: any
  updateBorrowMutation: UseMutationResult<any, Error, void>
}

export function ReturnModal({
  opened,
  onClose,
  returnEndDate,
  setReturnEndDate,
  activeBorrow,
  updateBorrowMutation,
}: ReturnModalProps) {
  const { t } = useTranslation("app_server")

  return (
    <DefaultModal opened={opened} onClose={onClose} title={t("Return")}>
      {activeBorrow && (
        <Stack gap="md">
          <DatePickerInput
            label={t("ReturnDate")}
            value={returnEndDate ?? undefined}
            onChange={(value) =>
              setReturnEndDate(value ? new Date(value) : null)
            }
          />
          <Group justify="flex-end" gap="md">
            <Button variant="default" onClick={onClose}>
              {t("Cancel")}
            </Button>
            <Button
              color="blue"
              onClick={() => updateBorrowMutation.mutate()}
              loading={updateBorrowMutation.isPending}
            >
              {t("Return")}
            </Button>
          </Group>
        </Stack>
      )}
    </DefaultModal>
  )
}
